// extracted by mini-css-extract-plugin
module.exports = {"root":"LogoLink__root--Tnc_H","logoContainer":"LogoLink__logoContainer--qWXll","bounce":"LogoLink__bounce--1vJNE"};